import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function BookingBoothComponent() {
  const [branches, setBranches] = useState([]);
  const [boothActive, setBoothActive] = useState([]);
  const [showList, setShowList] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    date: '',
    starttime: '',
    endtime: '',
  });
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const message = sessionStorage.getItem('successMessage');
    if (message) {
      setSuccessMessage(message);
      sessionStorage.removeItem('successMessage'); // Clear the message after displaying
      setTimeout(() => setSuccessMessage(''), 3000); // Hide the message after 3 seconds
    }
    const fetchBranches = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/branch');
        setBranches(response.data);
      } catch (error) {
        console.error('Error fetching branches:', error);
      }
    };
    fetchBranches();
  }, []);

  const fetchBoothActive = async (branchID, dateStartTime, dateEndTime) => {
    try {
      const response = await axios.get(`https://fboothapi.azurewebsites.net/api/booth/active-booth?branchID=${branchID}&startTime=${dateStartTime}&endTime=${dateEndTime}`);
      setBoothActive(response.data);
    } catch (error) {
      console.error('Error fetching active booths:', error);
    }
  };

  const handleSaveChange = async () => {
    if (!selectedBranch || !formData.date || !formData.starttime || !formData.endtime) {
      console.error("Please select a branch, date, and time.");
      return;
    }

    const [year, month, day] = formData.date.split("-");
    const [hours, minutes] = formData.starttime.split(":");

    const dateStartTime = new Date(year, month - 1, day, hours, minutes, 0);
    const dateStartTimeString = dateStartTime.toISOString();
    const dateEndTime = new Date(year, month - 1, day, hours, minutes, 0);
    const dateEndTimeString = dateEndTime.toISOString();

    await fetchBoothActive(selectedBranch.branchID, dateStartTimeString, dateEndTimeString);
    setShowList(true);
  };

  const handleBranchChange = (e) => {
    const selected = branches.find((branch) => branch.branchID === e.target.value);
    setSelectedBranch(selected);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleBookIt = (item) => {
    const bookingData = { ...formData, selectedBranch, booth: item };
    sessionStorage.setItem('bookingData', JSON.stringify(bookingData));
    navigate('/chooseservice');
  };

  const handleBack = () => {
    navigate('/profile');
  };

  return (
    <div className="">
      {successMessage && (
        <div className="fixed top-0 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded">
          {successMessage}
        </div>
      )}
      <h1 className="pt-10 pb-5 text-center text-4xl font-semibold text-titleTableFamous">Booking Booth for Customer</h1>
      <div className="flex items-center justify-center px-12 pb-40">
        <div className="shadow min-w-full rounded-lg p-16 bg-white">
          <form>
            <div className='-mx-3 flex flex-wrap mb-5'>
              <div className="w-full px-3 sm:w-1/2">
                <label htmlFor="branch" className="mb-3 block text-base font-medium text-[#07074D]">
                  Branch
                </label>
                <select
                  name="branch"
                  id="branch"
                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  onChange={handleBranchChange}
                >
                  <option value="">Select a Branch</option>
                  {branches.map((branch) => (
                    <option key={branch.branchID} value={branch.branchID}>
                      {branch.branchName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full px-3 sm:w-1/2">
                <label htmlFor="date" className="mb-3 block text-base font-medium text-[#07074D]">
                  Date
                </label>
                <input
                  type="date"
                  name="date"
                  id="date"
                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  value={formData.date}
                  onChange={handleInputChange}
                />
              </div>

            </div>
            <div className='-mx-3 flex flex-wrap mb-5'>
              <div className="w-full px-3 sm:w-1/2">
                <label htmlFor="time" className="mb-3 block text-base font-medium text-[#07074D]">
                  Start Time
                </label>
                <input
                  type="time"
                  name="starttime"
                  id="starttime"
                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  value={formData.starttime}
                  onChange={handleInputChange}
                />
                <p>Please select a time at least 30 minutes before check-in time</p>
              </div>
              <div className="w-full px-3 sm:w-1/2">
                <label htmlFor="time" className="mb-3 block text-base font-medium text-[#07074D]">
                  End Time
                </label>
                <input
                  type="time"
                  name="endtime"
                  id="endtime"
                  className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                  value={formData.endtime}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </form>
          <div className='flex justify-center mt-5'>
            <button
              className="px-8 py-3 border-blue-500 border text-blue-500 rounded transition duration-300 hover:bg-blue-700 hover:text-white focus:outline-none"
              onClick={handleSaveChange}
            >
              Show Active Booth
            </button>
          </div>
          {showList && (
            <div className="pt-3 overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Booth Name
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      People
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th scope="col" className="relative px-6 py-3">
                      <span className="sr-only">Book</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {boothActive.map((item) => (
                    <tr key={item.boothID}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.boothName}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.pricePerHour}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.status}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          className="px-5 py-2 border-blue-500 border text-blue-500 rounded transition duration-300 hover:bg-blue-700 hover:text-white focus:outline-none"
                          onClick={() => handleBookIt(item)}
                        >
                          Book it
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="flex justify-center mt-5">
            <button
              className="px-8 py-3 border-gray-500 border text-gray-500 rounded transition duration-300 hover:bg-gray-700 hover:text-white focus:outline-none"
              onClick={handleBack}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
